export default "__VITE_ASSET__CGZk9T3s__"